import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface AdBannerProps {
  slot: string;
  format?: 'auto' | 'fluid' | 'rectangle';
  responsive?: 'true' | 'false';
  layoutKey?: string;
  style?: React.CSSProperties;
}

const AdBanner: React.FC<AdBannerProps> = ({ slot, format = 'auto', responsive = 'true', layoutKey, style }) => {
  const { pathname } = useLocation();
  const adRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    try {
      const windowAny = window as any;
      const adsbygoogle = (windowAny.adsbygoogle = windowAny.adsbygoogle || []);

      // すでに広告が読み込まれている（status="done"）か、要素がない場合は何もしない
      const status = adRef.current?.getAttribute('data-adsbygoogle-status');
      if (adsbygoogle && !status) {
        adsbygoogle.push({});
      }
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, [pathname]); 

  return (
    <div 
      key={pathname} 
      style={{ 
        overflow: 'hidden', 
        textAlign: 'center', 
        margin: '20px 0',
        minHeight: '100px', // 広告が表示される前のガタつき防止
        maxHeight: '100px', // 縦に突き抜けるのを防ぐための最大高さ制限（広告サイズをある程度維持）
        ...style
      }}
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-1656424757905016" // 例: ca-pub-1234567890123456
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive}
        {...(layoutKey ? { 'data-ad-layout-key': layoutKey } : {})}
      />
    </div>
  );
};

export default AdBanner;